;(function ( $ ) {

    /**
     *  formValidate
     *  check if all required fields are valid
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'formValidate';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.registerEvents();
        },

        registerEvents: function() {
            var _this = this;
            var okRequire;
            var okValidate;
            $(this.element).on('submit', function(e) {
                _this.$requiredFields = $(_this.element).find('.required');
                _this.$validateFields = $(_this.element).find('.validate');
                okRequire = _this.checkRequiredFields();
                okValidate = _this.checkValidateFields();
                if (!okRequire || !okValidate) {
                    $(window).trigger('form.has-errors');
                    e.preventDefault();
                }
            });
            $(window).on('form.validate-do', function() {
                _this.$requiredFields = $(_this.element).find('.required');
                _this.$validateFields = $(_this.element).find('.validate');
                okRequire = _this.checkRequiredFields();
                okValidate = _this.checkValidateFields();
                if (!okRequire || !okValidate) {
                    $(window).trigger('form.has-errors');
                } else {
                    $(window).trigger('form.valid');
                }
            });
        },

        checkRequiredFields: function() {
            var ok = true;
            this.$requiredFields.filter(':visible').each(function(index, elem) {
                if (!$(this).val()) {
                    $(this).trigger('required-msg.show');
                    ok = false;
                }
            });
            return ok;
        },

        checkValidateFields: function() {
            var ok = true;
            this.$validateFields.filter(':visible').each(function(index, elem) {
                if ($(this).hasClass('validate-email')) {
                    if ($(this).val()) {
                        var expr = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
                        if (!expr.test($(this).val())) {
                            $(this).trigger('validate-msg.show');
                            ok = false;
                        }
                    }
                }
            });
            return ok;
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
